import { Eye, More, SearchNormal1 } from "iconsax-react";
import React, { useEffect, useState } from "react";
import { LSSB } from "../utils/LSSB_live";
import { useQuery } from "@tanstack/react-query";
import Moment from "moment";
import { University } from "../component.js/data";
import { useNavigate } from "react-router-dom";

const MyApplication = () => {
  const [state, setState] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  const [timeOfDay, setTimeOfDay] = useState("");

  useEffect(() => {
    const getCurrentTimeOfDay = () => {
      const currentHour = new Date().getHours();
      if (currentHour >= 5 && currentHour < 12) {
        return "Morning";
      } else if (currentHour >= 12 && currentHour < 18) {
        return "Afternoon";
      } else {
        return "Evening";
      }
    };

    setTimeOfDay(getCurrentTimeOfDay());
  }, []);

  function formatDate(datetimeStr) {
    const date = Moment(datetimeStr);
    const formattedDate = date.format("MMM DD, YYYY");
    return formattedDate;
  }

  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);

  const fetchApplications = async (page) => {
    let res = await LSSB.make_API_call({
      _endpoint: "fetch_applications",
      $k: userData.token,
      $page: 1,
      $items_per_page: 10, // or 10 default,
      $join: {
        // @@ aggregate data from another collection (or table in SQL terms)
        collection: "applicants",
        id_key: "_fields.applicant_id", // @@ id_key on this data to aggregate on the $join collection, applicant_id in this case
      },
      $where: {},

      $where: {
        "_fields.applicant_id": userData.user?._id,
        "_fields.application_status": state,
      },
      // $items_per_page: 10 -- default is 10
    });
    return res;
  };
  const ApplicationQuery = useQuery(["g", page, state], () =>
    fetchApplications(page)
  );
  const Applications = ApplicationQuery?.data?.data?.data || [];

  const pendingApplication = Applications?.filter(
    (item) => item?.Application_Status === "pending"
  ).length;
  const approvedApplication = Applications?.filter(
    (item) => item?.Application_Status === "Approved"
  ).length;
  const rejectedApplication = Applications?.filter(
    (item) => item?.Application_Status === "Rejected"
  ).length;

  return (
    <div className="p-[16px] md:px-[24px] xl:p-[32px]">
      <div className="mb-[24px] md:mb-[28px] xl:mb-[32px]">
        <h3 className="text-[18px] md:text-[24px] font-meddium text-[#25324B]">
          Good {timeOfDay}, {userData?.user?._fields?.fullname}
        </h3>
        <p className="text-[14px] md:text-[16px] font-meddium text-[#7C8493]">
          {" "}
          These are your applications
        </p>
      </div>

      <ul className="flex items-center gap-[20px] md:gap-[32px] border-b border-[#7C8493] mb-[42px]">
        <button onClick={() => setState("")}>
          <li
            className={`py-[10px] text-[14px] ${
              state === ""
                ? "font-medium text-[#000] border-b-[2.4px]"
                : "font-normal text-[#667185]"
            }  flex items-center justify-between border-b-[#AF8544]`}
          >
            <div className="">
              <p className="">All ({Applications.length})</p>
            </div>
          </li>
        </button>
        <button onClick={() => setState("pending")}>
          <li
            className={`py-[10px] text-[14px] ${
              state === "pending"
                ? "font-medium text-[#000] border-b-[2.4px]"
                : "font-normal text-[#667185]"
            }  flex items-center justify-between border-b-[#AF8544]`}
          >
            <div className="">
              <p className="">Pending ({pendingApplication})</p>
            </div>
          </li>
        </button>
        <button onClick={() => setState("Awarded")}>
          <li
            className={`py-[10px] text-[14px] ${
              state === "Awarded"
                ? "font-medium text-[#000] border-b-[2.4px]"
                : "font-normal text-[#667185]"
            }  flex items-center justify-between border-b-[#AF8544]`}
          >
            <div className="">
              <p className="">Awarded ({approvedApplication})</p>
            </div>
          </li>
        </button>

        <button onClick={() => setState("Rejected")}>
          <li
            className={`py-[10px] text-[14px] ${
              state === "Rejected"
                ? "font-medium text-[#000] border-b-[2.4px]"
                : "font-normal text-[#667185]"
            }  flex items-center justify-between border-b-[#AF8544]`}
          >
            <div className="">
              <p className="">Rejected ({rejectedApplication})</p>
            </div>
          </li>
        </button>
      </ul>

      <div className="rounded-lg overflow-hidden border-[0.8px] border-[#E4E7EC] mt-5 md:mt-9">
        <div className="flex items-center justify-between bg-white p-3">
          <p className=" text-[16px] md:text-lg  text-[#000] leading-[24px] font-medium text-left ">
            Recent Applications
          </p>
          {/* <div className=" relative  mt-[16px]  flex items-center">
          <SearchNormal1 size="24" className="absolute left-[4px]" />

              <input
                type="text"
                placeholder="Search Applications"
                className="w-[270px] h-[48px] pl-[36px] py-[12px] text-[14px] text-[#344054] bg-[#F9FAFB] leading-[20px]  placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D0D5DD] border-[0.2px] rounded-[8px] focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
             
                name="full-name"
                id="full-name"
                //value=""
                //onChange={() => {}}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div> */}
        </div>
        <div className="overflow-x-auto rounded-lg">
          <table className="min-w-full mb-6 border-[0.8px] border-r-[0.8px]  border-l-[0.8px] border-[#E4E7EC] rounded-lg">
            <thead className="bg-light-gray">
              <tr className="">
                <th
                  scope="col"
                  className=" px-2 md:px-5 border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex  gap-[6px] md:gap-[12px] items-center my-0">
                    Grant Title
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex  gap-[6px] md:gap-[12px] items-center my-0">
                    Education Level
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex  gap-[6px] md:gap-[12px] items-center my-0">
                    Institution
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex  gap-[6px] md:gap-[12px] items-center my-0">
                    Date Applied
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex gap-[6px] md:gap-[12px] items-center my-0">
                    Status
                  </div>
                </th>
                <th
                  scope="col"
                  className="px-2 md:px-5  border-b-[0.8px] border-[#E4E7EC] py-[12px] gap-[6px] md:gap-[12px] text-[14px] md:text-[16px] text-[#98A2B3]  font-medium leading-[20px] md:leading-[24px] tracking-[0.2%]"
                >
                  <div className="flex gap-[6px] md:gap-[12px] items-center my-0">
                    Action
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading && <div>Loading...</div>}
              {!isLoading && Applications.length === 0 && (
                <tr>
                  <td className="text-center" colspan="6">
                    <img
                      src="./nodata.gif"
                      className="mx-auto mt-6 h-[70px] "
                      alt=""
                    />
                    <h3 className="text-[30px] leading-[35px]  text-[#1A202C] font-extrabold mb-[6px]">
                      No Application
                    </h3>
                  </td>
                </tr>
              )}
              {Applications &&
                Applications?.map((result, index) => (
                  <tr
                    onClick={() =>
                      navigate("/application/application-details", {
                        state: result,
                      })
                    }
                    key={index}
                    className="mb-2 hover:bg-light-gray cursor-pointer"
                  >
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {result?.Grant}
                    </td>

                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {result?.Edu_Level}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {University &&
                        University.map(
                          (uni, index) =>
                            result?.Institution === uni.value && (
                              <span key={index}>{uni.text}</span>
                            )
                        )}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {formatDate(result?.Date_Applied)}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      {" "}
                      <button
                        className={`rounded-[20px] md:rounded-[40px] flex justify-center items-center gap-2 px-[12px]  py-[4px] md:py-[4px] border-[0.5px] ${
                          result?.Application_Status === "Rejected"
                            ? "bg-[#FEECEB] text-[#F44336] border-[#F44336]"
                            : result?.Application_Status === "pending"
                            ? "bg-[#FFF5E6] text-[#F44336] border-[#FF9800]"
                            : "bg-[#EDF7EE] text-[#4CAF50] border-[#4CAF50]"
                        }  text-[10px] md:text-[12px]  font-semibold leading-[16px] md:leading-[18px] `}
                      >
                        <p>{result?.Application_Status}</p>
                      </button>{" "}
                    </td>
                    <td className="whitespace-nowrap py-[16px] bg-white  px-5  border-b-[0.8px] border-[#E4E7EC] text-[14px] leading-[24px] tracking-[0.2px] text-[#667185] font-medium text-left  ">
                      <Eye variant="Linear" color="green" size="20" />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default MyApplication;
